var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPrivateroom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 28V17.3333C20.5 16.9797 20.3595 16.6406 20.1095 16.3905C19.8594 16.1405 19.5203 16 19.1667 16H13.8333C13.4797 16 13.1406 16.1405 12.8905 16.3905C12.6405 16.6406 12.5 16.9797 12.5 17.3333V28",
    stroke: "#6938EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 13.3333C4.49991 12.9454 4.58445 12.5622 4.74772 12.2103C4.91099 11.8584 5.14906 11.5464 5.44533 11.296L14.7787 3.29733C15.26 2.89054 15.8698 2.66736 16.5 2.66736C17.1302 2.66736 17.74 2.89054 18.2213 3.29733L27.5547 11.296C27.8509 11.5464 28.089 11.8584 28.2523 12.2103C28.4156 12.5622 28.5001 12.9454 28.5 13.3333V25.3333C28.5 26.0406 28.219 26.7189 27.719 27.2189C27.2189 27.719 26.5406 28 25.8333 28H7.16667C6.45942 28 5.78115 27.719 5.28105 27.2189C4.78095 26.7189 4.5 26.0406 4.5 25.3333V13.3333Z",
    stroke: "#6938EF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateroom);
export default __webpack_public_path__ + "static/media/privateroom.3093e155e2997b5034fb122ff1375660.svg";
export { ForwardRef as ReactComponent };